import * as React from 'react';
import H3 from '@sdk/components/ui/typography/H3';
import StatusLabel from '@sdk/components/ui/StatusLabel';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text14 from '@sdk/components/ui/typography/Text14';
import Row from '@sdk/components/ui/spacing/Row';
import gettext from '@sdk/lang/gettext';

import {
  BillingPlanStatus as BillingPlanStatusType,
  BillingPlans,
} from '../hooks/billingPlans.hooks';

import BillingPlanActions from './BillingPlanActions';
import {
  BillingSectionColumn,
  PriceDisplay,
  PlanStatusLabel,
  PlanTitle,
  PlanTitleInfo,
} from './billingPlans.styles';

type Props = {
  plan: BillingPlanStatusType;
  showStatusLabel: boolean;
  isPlanAnnual: boolean;
  isCurrentPlan: boolean;
  level: number;
  goToPurchase: (plan: number, isAnnual: boolean) => void;
  billingPlans: BillingPlans;
  isOnHighestLevel: boolean;
  isAlreadySubscribed: boolean;
  isSubscriptionCancellationPeriod: boolean;
  upgradeSubscriptionLevel: () => void;
  isToastBilling: boolean;
};

const BillingPlanStatus: React.FC<React.PropsWithChildren<Props>> = ({
  plan,
  showStatusLabel,
  isPlanAnnual,
  isCurrentPlan,
  level,
  goToPurchase,
  billingPlans,
  isOnHighestLevel,
  upgradeSubscriptionLevel,
  isAlreadySubscribed,
  isSubscriptionCancellationPeriod,
  isToastBilling,
}) => (
  <BillingSectionColumn>
    <H3 themeColor={ThemeColorType.primary}>
      <PlanTitle>
        {plan.name}{' '}
        <PlanTitleInfo>
          {plan.name === gettext('Free') && gettext('(up to 30 people)')}
        </PlanTitleInfo>
        <PlanStatusLabel>
          {(showStatusLabel && (
            <StatusLabel label={isCurrentPlan ? gettext('Your plan') : gettext('Recommended')} />
          )) ||
            null}
        </PlanStatusLabel>
      </PlanTitle>
    </H3>
    <Text14 top={20} themeColor={ThemeColorType.gray}>
      {plan.description}
    </Text14>
    {!isToastBilling && (
      <Row mTop={20}>
        {level == 0 ? (
          <Text14 themeColor={ThemeColorType.gray}>{gettext('Free')}</Text14>
        ) : (
          <>
            <PriceDisplay themeColor={ThemeColorType.primary} semiBold>
              {plan.price}
            </PriceDisplay>
            <Text14 themeColor={ThemeColorType.gray}>{gettext('per user per month')}</Text14>
          </>
        )}
      </Row>
    )}
    {(!isOnHighestLevel && (
      <BillingPlanActions
        level={level}
        isPlanAnnual={isPlanAnnual}
        goToPurchase={goToPurchase}
        billingPlans={billingPlans}
        upgradeSubscriptionLevel={upgradeSubscriptionLevel}
        isAlreadySubscribed={isAlreadySubscribed}
        isSubscriptionCancellationPeriod={isSubscriptionCancellationPeriod}
        isToastBilling={isToastBilling}
      />
    )) ||
      null}
  </BillingSectionColumn>
);

export default BillingPlanStatus;
